/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useCallback, useState } from 'react';

import { Layout } from '~/components';

import { ControlPanel } from './ControlPanel';
import { PrescriptionScreen } from './PrescriptionScreen';

import { Container, Sidebar, Wrapper } from './styles';

const TrainingProtocol = () => {
  const [lockNextScreen, setLockNextScreen] = useState(true);
  const [selectedComponent, setSelectedComponent] = useState('prescription');

  const sidebarList = [
    {
      value: 'prescription',
      title: 'Prescrições',
    },
    {
      value: 'controlPanel',
      title: 'Painel de controle',
    },
  ];

  function lockScreen(value: boolean) {
    setLockNextScreen(value);
  }

  const sidebarSelectedComponent: { [key: string]: JSX.Element } = {
    controlPanel: <ControlPanel />,
    prescription: <PrescriptionScreen lockNextScreen={lockScreen} />,
  };

  const handleTabChange = useCallback((value: string) => {
    setSelectedComponent(value);
  }, []);

  return (
    <Layout title="Aluno">
      <Container>
        <Sidebar>
          <ul>
            {sidebarList.map((item) => (
              <li
                key={item.value}
                onClick={() => handleTabChange(item.value)}
                className={selectedComponent === item.value ? 'active' : ''}
              >
                <p>{item.title}</p>
              </li>
            ))}
          </ul>
        </Sidebar>
        <Wrapper>{sidebarSelectedComponent[selectedComponent]}</Wrapper>
      </Container>
    </Layout>
  );
};

export default TrainingProtocol;
